import { AuthAlert } from "@/components/auth/auth-alert";

/** Full-page "couldn't load your account" state with a Retry action. */
export function LoadFailed({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6">
      <div className="w-full max-w-sm">
        <AuthAlert>We couldn&apos;t load your account. Check your connection and try again.</AuthAlert>
      </div>
      <button
        type="button"
        className="rounded-md border border-border px-3 py-1.5 text-sm font-medium focus-visible:outline-2 focus-visible:outline-offset-2"
        onClick={onRetry}
      >
        Retry
      </button>
    </div>
  );
}
